import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div>
      <section className="hero">
        <div className="container">
          <h1>Rental Property Management</h1>
          <p>Flexible Plans That Scale With Your Business</p>
          <p>Find the right fit for your rental property portfolio. With multiple pricing plans to choose from and opportunities to be flexible, get exactly what you need to operate at the top of your game.</p>
          <Link to="/contact" className="btn btn-primary" style={{ marginRight: '20px' }}>
            Book a Free Demo
          </Link>
          <Link to="/pricing" className="btn btn-secondary">
            View Pricing
          </Link>
        </div>
      </section>

      <section style={{ padding: '60px 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', marginBottom: '40px' }}>Rental Property Solutions</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
            <div style={{ textAlign: 'center', padding: '30px' }}>
              <h3>Rental Manager</h3>
              <p>Comprehensive rental management tools for residential properties</p>
            </div>
            <div style={{ textAlign: 'center', padding: '30px' }}>
              <h3>Portfolio Manager</h3>
              <p>Advanced analytics and reporting for rental portfolios</p>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '60px 0', background: '#f8f9fa' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Everything Your Business Needs in One Spot</h2>
          <h3 style={{ textAlign: 'center', marginBottom: '40px', color: '#007bff' }}>Communication & Service</h3>
          <p style={{ textAlign: 'center', marginBottom: '50px', fontSize: '18px', maxWidth: '800px', margin: '0 auto 50px' }}>
            With unified communication tools, you can effortlessly keep your residents, owners, and investors happy and in the loop.
          </p>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px' }}>
            <div style={{ background: 'white', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
              <h4 style={{ marginBottom: '15px', color: '#333' }}>Multi-Channel Inbox</h4>
              <p style={{ color: '#666', fontSize: '14px' }}>Centralized communication hub for all resident and owner interactions</p>
            </div>
            <div style={{ background: 'white', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
              <h4 style={{ marginBottom: '15px', color: '#333' }}>Email & SMS Templates</h4>
              <p style={{ color: '#666', fontSize: '14px' }}>Pre-built templates for consistent, professional communication</p>
            </div>
            <div style={{ background: 'white', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
              <h4 style={{ marginBottom: '15px', color: '#333' }}>Owner & Vendor Portals</h4>
              <p style={{ color: '#666', fontSize: '14px' }}>Self-service portals for owners and vendors to access information</p>
            </div>
            <div style={{ background: 'white', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
              <h4 style={{ marginBottom: '15px', color: '#333' }}>Resident Portal & Inbox</h4>
              <p style={{ color: '#666', fontSize: '14px' }}>Dedicated resident communication and service request platform</p>
            </div>
            <div style={{ background: 'white', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
              <h4 style={{ marginBottom: '15px', color: '#333' }}>Online Documents</h4>
              <p style={{ color: '#666', fontSize: '14px' }}>Digital document management and e-signature capabilities</p>
            </div>
            <div style={{ background: 'white', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
              <h4 style={{ marginBottom: '15px', color: '#333' }}>Resident Surveys & Reviews</h4>
              <p style={{ color: '#666', fontSize: '14px' }}>Collect feedback and maintain high satisfaction ratings</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;